/* Updated terminology: ECost -> Exchange Cost */
import React,{useState,useEffect} from 'react';
import {supabase} from '../lib/supabase';
import DataTable from '../components/DataTable';
import DataModal from '../components/DataModal';

const TABLE_NAME='rox_items_1740635000';
const columns=[ 
  {key: 'item_name',label: 'Item Name'},
  {key: 'category',label: 'Category'},
  {key: 'sub_category',label: 'Sub Category'},
  {key: 'material_1',label: 'Material 1'},
  {key: 'qty_1',label: 'Qty 1'},
  {key: 'material_2',label: 'Material 2'},
  {key: 'qty_2',label: 'Qty 2'},
  {key: 'e_cost',label: 'Exchange Cost'} 
];

const formFields=[ 
  {name: 'item_name',label: 'Item Name',type: 'text',required: true},
  {name: 'category',label: 'Category',type: 'text'},
  {name: 'sub_category',label: 'Sub Category',type: 'text'},
  {name: 'material_1',label: 'Material 1',type: 'text'},
  {name: 'qty_1',label: 'Quantity 1',type: 'number'},
  {name: 'material_2',label: 'Material 2',type: 'text'},
  {name: 'qty_2',label: 'Quantity 2',type: 'number'},
  {name: 'e_cost',label: 'Exchange Cost',type: 'number'} 
];

export default function Items() {
  const [data,setData]=useState([]);
  const [isLoading,setIsLoading]=useState(true);
  const [isModalOpen,setIsModalOpen]=useState(false);
  const [editingItem,setEditingItem]=useState(null);

  const fetchData=async ()=> {
    setIsLoading(true);
    const {data: items,error}=await supabase
      .from(TABLE_NAME)
      .select('*')
      .order('item_name',{ascending: true});
    if (!error && items) setData(items);
    setIsLoading(false);
  };

  useEffect(()=> {fetchData();},[]);

  const handleSave=async (formData)=> {
    const {error}=await supabase
      .from(TABLE_NAME)
      .upsert(formData,{onConflict: 'item_name'});
    if (!error) {
      fetchData();
      setIsModalOpen(false);
    } else {
      alert('Error saving data: ' + error.message);
    }
  };

  const openAddModal=()=> {
    setEditingItem(null);
    setIsModalOpen(true);
  };

  const openEditModal=(item)=> {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  return ( 
    <> 
      <DataTable title="Items" columns={columns} data={data} isLoading={isLoading} onAdd={openAddModal} onEdit={openEditModal} /> 
      <DataModal isOpen={isModalOpen} onClose={()=> setIsModalOpen(false)} onSave={handleSave} fields={formFields} initialData={editingItem} title={editingItem ? 'Edit Item' : 'Add Item'} /> 
    </> 
  );
}